import React from 'react';

import { SiteNavLink } from 'clipsal-cortex-ui/src/components/bottom-nav/custom-nav-hooks';

import { SEHomeEVChargerIcon, SEHomeNavActivityIcon, SEHomeNavNotificationsIcon } from '../../styles/custom-icons';

const COMMON_NAV_ICON_PROPS = {
  width: '30px',
  height: '30px',
};

// Configure site-level routes in this array
// eslint-disable-next-line react-refresh/only-export-components
export const NAV_LINKS: SiteNavLink[] = [
  {
    route: '/home/device-status',
    icon: <SEHomeEVChargerIcon {...COMMON_NAV_ICON_PROPS} />,
    activeIcon: <SEHomeEVChargerIcon {...COMMON_NAV_ICON_PROPS} />,
    ariaLabel: 'Home',
    routeName: 'Device-Status',
  },
  {
    route: '/home/device-charging-activity',
    icon: <SEHomeNavActivityIcon {...COMMON_NAV_ICON_PROPS} />,
    activeIcon: <SEHomeNavActivityIcon {...COMMON_NAV_ICON_PROPS} />,
    ariaLabel: 'Activity',
    routeName: 'Device-Charging-Activity',
  },
  {
    route: '/notifications',
    icon: <SEHomeNavNotificationsIcon {...COMMON_NAV_ICON_PROPS} />,
    activeIcon: <SEHomeNavNotificationsIcon {...COMMON_NAV_ICON_PROPS} />,
    ariaLabel: 'Notifications',
    routeName: 'Notifications',
  },
];
